import React from 'react';
import PropTypes from 'prop-types';
import { Popover, PopoverBody } from "reactstrap";
import ValidationButton from './ValidationButton';

export default class ModalButtonRow extends React.Component {
  helpRef = React.createRef();

  state = {
    popoverOpen: false
  };

  static propTypes = {
    toggle:       PropTypes.func.isRequired,
    submitAction: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    valid:        PropTypes.bool
  };

  togglePopover = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  render() {
    const flexTextStyle = { display: "flex", flexDirection: "column", justifyContent: "center", marginRight: "auto" };

    const { toggle, submitAction, errorMessage, valid } = this.props;
    const { popoverOpen } = this.state;

    return (
      <div style={{ width: "100%", display: "flex" }}>
        <span ref={this.helpRef} style={flexTextStyle} className="ui-help-text" data-label="move-help-popover" onClick={this.togglePopover}>
          What happens when I move a Promo Number?
        </span>

        <Popover placement="top" isOpen={popoverOpen} target={this.helpRef} toggle={this.togglePopover}>
          <PopoverBody>
            Invoca will send phone calls to your new destination campaign instead of its current campaign.
            Before you move a promo number, we highly recommend that you pause the campaign you are moving it from to prevent errors.
          </PopoverBody>
        </Popover>

        <button className="btn btn-secondary" type="button" onClick={toggle}>Cancel</button>

        <ValidationButton
          className="btn btn-primary"
          buttonAction={submitAction}
          buttonText="Move"
          errorMessage={errorMessage}
          valid={valid}
        />
      </div>
    );
  }
}
